// extracted by mini-css-extract-plugin
module.exports = {"WorkoutVerticalChart":"WorkoutVerticalChart_WorkoutVerticalChart__1KG-s","titleCardSimple":"WorkoutVerticalChart_titleCardSimple__5eX_L"};